import React from 'react';
import { withFormsy } from 'formsy-react';
import PropTypes from 'prop-types';
import Radium from 'radium';
// Make sure to import default styles.
// This only needs to be done once; probably during bootstrapping process.
import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';

// Then import the virtualized Select HOC
import VirtualizedSelect from 'react-virtualized-select';

const style = {
  border: '2px solid #17E685',
  width: '100%',
  outline: 'none',
  borderRadius: '0px',
};

class BorderedSelect extends React.Component {
  constructor(props) {
    super(props);
    this.changeValue = this.changeValue.bind(this);
  }

  changeValue(value) {
    this.props.setValue(value.value);
  }

  render() {
    // An error message is returned only if the component is invalid
    const errorMessage = this.props.getErrorMessage();
    const { getValue, name } = this.props;

    const options = this.props.options.map(option => ({
      label: option.title,
      value: option.value,
    }));

    return (
      <div style={this.props.style}>
        <VirtualizedSelect
          options={options}
          onChange={this.changeValue}
          value={getValue() || ''}
          name={name}
          style={style}
          clearableValue={false}
          clearable={false}
          searchable={false}
        />
        <span className="validation-error">{errorMessage}</span>
      </div>
    );
  }
}

BorderedSelect.defaultProps = {
  name: '',
  placeholder: '',
};

BorderedSelect.propTypes = {
  name: PropTypes.string.isRequired,
  getValue: PropTypes.func.isRequired,
  getErrorMessage: PropTypes.func.isRequired,
  setValue: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(Object).isRequired,
};

export default withFormsy(Radium(BorderedSelect));



// WEBPACK FOOTER //
// ./src/components/Formsy/BorderedSelect.js